import styled from 'styled-components'

export const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
    display: grid;
  }
`
export const UserSoldContainer = styled.div`

    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top:40px;

    @media (max-width: 768px) {
    width: 490px;
    margin-right: 20px;
  }


`
export const UserSoldLeftContainer = styled.div`
    border: 3px solid #7e7d7a;
    display: flex;
    flex-direction: column;
    margin-right:50px;
    width:25%;
    height:60%;
    border-radius: 15px;

    i{
            margin:8px 8px;
            font-size:40px;

        }
`
export const PerfilPictureContainer = styled.div`

    .perfil-picture-background{
            border-radius: 50%;
            border:6px solid black;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 251px;
            height: 251px;
            margin: 20px 50px;
    }

        img{
            width: 244px;
            height: 244px;
            border-radius:50%;
            }

`
export const UserSoldFeatureContainerBotton = styled.div`

    display:flex;
    align-items:flex-start;
    flex-direction:column;
    margin:30px;


`
export const PerfilNameSinceContainer = styled.div`

    .user-name-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color: #002666;
            font-weight:bold;
    }

    .user-since-container{
            display: flex;
            align-items: center;
            justify-content: center;
            color:#535353;
            font-weight:bold;
            font-size:12px;

    }

`
export const MySellerContainer = styled.div`

        margin-top:10px;

    .my-seller{
        color:#303030;
        font-size:25px;
        display: flex;
        align-items: center;
        justify-content: center;
    }


    .my-seller-secondary-property{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin:20px;
        list-style:none;
    }
`
export const MyPurchaseContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;


`
export const PaymentContainer = styled.div`

    color:#303030;
    font-size:25px;
    display: flex;
    align-items: center;
    justify-content: center;
`
export const ConfigurationContainer = styled.div`


    .configuration{
        color:#303030;
        font-size:25px;
        display: flex;
        align-items: center;
        justify-content: center;

    }

    .configuration-secondary-property{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin:20px;
        list-style:none;

    }
`


// >>>>>>>>>>>CONTAINER DIREITO<<<<<<<<<<


export const UserFavoritesRightContainer = styled.div`
    border: 3px solid #7e7d7a;
    width:75%;
    height:35%;

    flex: 1;
    display: flex;
    flex-direction: column;
    border-radius:15px;
`
export const UserFavoritesTitle = styled.div`

    border-bottom: 2px solid #7e7d7a;
    display: flex;
    flex-direction:row;
    align-items: center;
    margin: 20px;
    color: #002666;
    font-size: 26px;
    margin-bottom:6px;
    margin-top: 60px;
    i{
        font-size:60px;
        margin-right: 20px;
    }

`
export const FavoritesContainerSubtitle = styled.div`
    display: flex;
    flex-direction:row;
    justify-content:space-between;
`
export const FavoritesFunctionalityLeft = styled.div`

    display: flex;
    flex-direction:row;
    font-style:bold;
    font-size: 20px;
    margin: 15px 5px 15px 20px;
    color: black;
    align-items:center;
    .favorites-checkbox-wrapper{
    display: flex;
    flex-direction:row;
    border: 1px solid;
    border-radius: 5px;
    width:30px;
    height:30px;
    padding: 5px;
    margin-right: 20px;
    }
    button{
        background:#b6adad;
        font-size:18px;
        width:100px;
        height:40px;
        border-radius: 12px;
    }


`
export const FavoritesFunctionalityRight = styled.div`
 display: flex;
 align-items: center;
 margin-right:50px;

`
export const FavoritesProductsContainer = styled.div`
        background-color:lightgray;
        border-radius:15px;
        justify-content: space-between;
        display: flex;
        flex-direction:row;
        padding: 5px 10px;
        margin: 10px 10px;
        align-items:center;

        .favorites-checkbox-wrapper{
        display: flex;
        flex-direction:row;
        border: 1px solid;
        border-radius: 5px;
        width:30px;
        height:30px;
        padding: 5px;
        margin-right: 5px;
        justify-items:center;
    }


        .product-picture{


            margin: 2px 8px 2px 12px;

            img{
            width: 150px;
            height: auto;
            margin: 5px;
            border-radius:15px;
            }

        }

    .description-general{

    display: flex;
    flex-direction: column;


    .USC-description-product{
        color:#ce1720;
    }
    .USC-description-status{
        color:#ce1720;
    }
    .USC-description-price{
        font-weight: bold;
    }
    .USC-parcelas{
        color:#002666;
    }

    }
    .button-elipse-container{
        display: flex;
        flex-direction:row;

        button{
        background:#ce1720;
        color:#d8e0ea;
        font-weight:bold;
        font-size:18px;
        width:170px;
        height:40px;
        border-radius: 8px;
        }


    }


`
// >>>>>>>>>>>>>>>>>>>Container Botton<<<<<<<<<<<<<<<<<


export const UserSoldContainerBot = styled.div`

    border: 3px solid #7e7d7a;
    display: flex;
    flex-direction:row;
    justify-content: space-between;
    align-items:center;
    border-radius:15px;
    top: 80px;
    width:170px;
    height:40px;
    position:relative;
    padding: 6px;
    background:#ce1720;


`